import { format } from 'date-fns';
import { toast } from 'react-toastify'; 
import { inspectionType  } from '../constants/generals';

import {
    saveDailyFormData,
    saveFlaggedDailyFormsData,
    saveFlaggedFormDetails,
    saveFlaggedMonthlyFormsData,
    saveFlaggedQuarterlyFormsData,
    saveLineChartData,
    saveMonthlyFormData,
    saveQuarterlyFormData,
    savePlantDetails
} from '../actions/dashboardAction';
import { SUBMISSION_FAILED } from '../constants/generals';
import { DailyFormsModel } from '../model/DailyFormModel';
import { FlaggedFormModel, IFlaggedFormModelProps } from '../model/FlaggedFormModel';
import { MonthlyFormModel } from '../model/MonthlyFormModel';
import { store } from '../store';
import { getCurrentUserUUID, marshallFormDetails, objectToArray, splitDate } from '../utils/generalUtils';
import { getDev, postDev } from '../utils/HTTPDev';

export async function getFormSummaryData(mm: string, dd: string, yyyy: string, region: string = 'All', instance?,
    identifier?: string) {
    const allDailyFormInstances = DailyFormsModel.list();
    allDailyFormInstances.forEach(instance => {
        new DailyFormsModel(instance.props).$delete();
    });
    const allMonthlyFormInstances = MonthlyFormModel.list();
    allMonthlyFormInstances.forEach(instance => {
        new MonthlyFormModel(instance.props).$delete();
    });
    try {
        const response = await getDev(`/getformscount/${mm}${dd}${yyyy}/${region}/${getCurrentUserUUID()}`);
        const Monthly = response.data.data.Monthly;
        const Quarterly = response.data.data.Quarterly;
        const dailyFormsData = marshallDailyFormData(response.data.data.Daily, mm);
        const monthlyFormsData = marshallMonthlyFormData(response.data.data.Monthly);
        saveDailyFormData(dailyFormsData);
        saveMonthlyFormData(monthlyFormsData);
        saveQuarterlyFormData(Quarterly);
        saveLineChartData({ dailyForms: dailyFormsData, Monthly, Quarterly });
        return response;
    } catch (error) {
        instance.setState({
            isLoading: false
        });
        throw error;
    }
}

export async function getIndividualFormSummary(mm: string, dd: string, yyyy: string,
    formType: string, region: string = 'All', instance?, ) {
    try {
        const response = await getDev(`/getformscount/${mm}${dd}${yyyy}/${region || 'All'}/${getCurrentUserUUID()}`);
        let dailyFormsData, MonthlyData, QuarterlyData;
        if(instance && instance=='init') {
            dailyFormsData = marshallDailyFormData(response.data.data.Daily, mm);
            saveDailyFormData(dailyFormsData);
            MonthlyData = marshallMonthlyFormData(response.data.data.Monthly);
            saveMonthlyFormData(MonthlyData);
            QuarterlyData = response.data.data.Quarterly;
            saveQuarterlyFormData(QuarterlyData);
            saveLineChartData({ dailyForms: dailyFormsData, Monthly: MonthlyData, Quarterly: QuarterlyData });
            return;
        }
        const lineChartData = store.getState().dashboard.get('lineChartData');
        dailyFormsData = lineChartData ? lineChartData.dailyForms : {};
        MonthlyData = lineChartData ? lineChartData.Monthly : {};
        QuarterlyData = lineChartData ? lineChartData.Quarterly : {};
        switch (formType) {
            case 'Daily':
                dailyFormsData = marshallDailyFormData(response.data.data.Daily, mm);
                saveDailyFormData(dailyFormsData);
                break;
            case 'Monthly':
                MonthlyData = marshallMonthlyFormData(response.data.data.Monthly);
                saveMonthlyFormData(MonthlyData);
                break;
            case 'Quarterly':
                QuarterlyData = response.data.data.Quarterly;
                saveQuarterlyFormData(QuarterlyData);
                break;
        }
        saveLineChartData({ dailyForms: dailyFormsData, Monthly: MonthlyData, Quarterly: QuarterlyData });
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        
        throw error;
    }
}
export function marshalDailyForms(dailyForms, mm: string, form: string) {
    if (mm.substring(0, 1) === '0') {
        mm = mm.substring(1, 2);
    }
    const data = {
        dailyFormsData: [],
        complete: 0,
        inComplete: 0,
        InCompletePlantIds: 0,
        CompletePlantIds: 0
    };
    for (let key in dailyForms[form][mm]) {
        data.dailyFormsData.push({
            [key]: dailyForms[form][mm][key]
        });
    }
    data.complete = dailyForms[form]['Complete'];
    data.inComplete = dailyForms[form]['InComplete'];
    data.InCompletePlantIds = dailyForms[form]['InCompletePlantIds'];
    data.CompletePlantIds = dailyForms[form]['CompletePlantIds'];
    return data;
}

export function marshallDailyFormData(dailyForms, mm: string) {
    const dailyFormsData = marshalDailyForms(dailyForms, mm, 'DailyForm');
    const PlantPreventiveData = marshalDailyForms(dailyForms, mm, 'PlantPreventive');
    const data = {
        DailyForm: dailyFormsData,
        PlantPreventive: PlantPreventiveData,
        InCompleteCount: dailyForms.InCompleteCount,
        CompletedCount: dailyForms.CompletedCount
    };
    return data;
}

export function marshallMonthlyFormData(data) {
    let monthlyFormData = {
        SPCC: {},
        SpillLogs: {},
        SW: {},
        USTRect: {},
        USTSpill: {},
    };
    monthlyFormData.SPCC = data.MonthlySPCC;
    monthlyFormData.SpillLogs = data.MonthlySpillLogs;
    monthlyFormData.SW = data.MonthlySW;
    monthlyFormData.USTRect = data.MonthlyUSTRect;
    monthlyFormData.USTSpill = data.MonthlyUSTSpill;
    return data;
}

export function mapDataToState(lineChartData, filterBy, self, index, filterData) { 
    const { dailyForms, Monthly, Quarterly } = lineChartData; 
    const filterDaily = filterBy || self.state.filterDailyBy;
    const filterMonthly = filterBy || self.state.filterMonthlyBy;
    const filterQuarterly = filterBy || self.state.filterQuarterlyBy;
    let barColors = ['59B1FF'];
    let dataKey = [filterMonthly];
    switch (index) {
        case 0:
            barColors = ['59B1FF', 'BFFF4C'];
            dataKey = [inspectionType('DailyForm'), inspectionType('PlantPreventive')];
            let dailyFormData = [];
            const { mm, dd, yyyy } = splitDate(format(filterData.date, 'YYYY-MM-DD'));
            if (filterBy && filterBy !== 'All') {
                barColors = [barColors[dataKey.indexOf(filterBy)]];
                dailyFormData = dailyForms[filterBy].dailyFormsData.map((value, index) => {
                    return { 
                        name: (index + 1).toString(), 
                        [filterBy]: value[index + 1], 
                        month: mm, year: yyyy, region: filterData.region || 'All'
                    };
                });
                dataKey = [filterBy];
            
            } else {
                dailyFormData = (dailyForms.DailyForm.dailyFormsData || []).map((value, index) => {
                    return { 
                        name: inspectionType( (index + 1).toString()) ,
                        [inspectionType('DailyForm')]: value[index + 1], 
                        [inspectionType('PlantPreventive')]: lineChartData.dailyForms.PlantPreventive.dailyFormsData[index][index + 1],
                        month: mm, year: yyyy, region: filterData.region || 'All'
                     }; 
                });
            }
            
            self.setState({
                lineChartData: dailyFormData,
                barColors,
                lineChartDataKey: dataKey
            });
            return;
        case 1:
            const monthlyFormsData = [];
            const barColorArray = ['59B1FF', '8F8BFF', 'FF6520', 'BFFF4C', '309DFF'];
            const dataKeys = ['MonthlySPCC', 'MonthlySpillLogs', 'MonthlySW', 'MonthlyUSTRect', 'MonthlyUSTSpill'];
            barColors = [barColorArray[dataKeys.indexOf(filterMonthly)]];
            if (filterBy && filterBy !== 'All') {
                for (const key in Monthly[filterMonthly]) {
                    if (key === 'Complete' || key === 'InComplete'
                        || key === 'InCompletePlantIds' || key === 'CompletePlantIds') {
                        continue;
                    }
                    monthlyFormsData.push({
                        name: key.toString(),
                        [filterMonthly]: Monthly[filterMonthly][key]
                    });
                }
            } else {
                dataKey = [inspectionType('MonthlySPCC'), inspectionType('MonthlySpillLogs'), inspectionType('MonthlySW'), inspectionType('MonthlyUSTRect'), inspectionType('MonthlyUSTSpill')];
                barColors = ['59B1FF', '8F8BFF', 'FF6520', 'BFFF4C', '309DFF'];
                for (let i = 1; i <= 12; i++) {
                    monthlyFormsData.push({
                        name: `${i}`,
                        [inspectionType('MonthlySPCC')]: Monthly.MonthlySPCC[i.toString()],
                        [inspectionType('MonthlySpillLogs')]: Monthly.MonthlySpillLogs[i.toString()],
                        [inspectionType('MonthlySW')]: Monthly.MonthlySW[i.toString()],
                        [inspectionType('MonthlyUSTRect')]: Monthly.MonthlyUSTRect[i.toString()],
                        [inspectionType('MonthlyUSTSpill')]: Monthly.MonthlyUSTSpill[i.toString()],
                    });

                }
            }
            self.setState({
                lineChartData: monthlyFormsData,
                barColors,
                lineChartDataKey: dataKey
            });
            return;
        case 2:
            let quarterlyFormsData = [];
            const barColorsArray = ['59B1FF', '8F8BFF'];
            const quarterDataKeys = ['QTRVisual', 'ShopInspection'];

            if (filterBy && filterBy !== 'All') {
                dataKey = [filterQuarterly];
                barColors = [barColorsArray[quarterDataKeys.indexOf(filterQuarterly)]];
                for (const key in Quarterly[filterQuarterly]) {
                    if (key === 'Complete' || key === 'InComplete' || key === 'InCompletePlantIds') {
                        continue;
                    }
                    quarterlyFormsData.push({
                        name: key.toString(),
                        [filterQuarterly]: Quarterly[filterQuarterly][key]
                    });
                }
            } else {
                dataKey = [inspectionType('QuarterVisual'), inspectionType('ShopInspection')];
                barColors = ['59B1FF', '8F8BFF'];
                const quaters = ['Quarter1', 'Quarter2', 'Quarter3', 'Quarter4'];
                quarterlyFormsData = quaters.map(quarter => {
                    return { 
                        name : `${quarter}`,
                        [inspectionType('QuarterVisual')]: Quarterly.QTRVisual[quarter],
                        [inspectionType('ShopInspection')]: Quarterly.ShopInspection[quarter]
                     };
                });

            }
            self.setState({
                lineChartData: quarterlyFormsData,
                barColors,
                lineChartDataKey: dataKey
            });
        default:
            return;
    }
}

export function constructChartData(lineChartData, dailyForms, monthlyForms, quarterlyForms, filterData?) {
    const { mm, dd, yyyy } = splitDate(format(filterData.date, 'YYYY-MM-DD'));
    const dailyFormData = [];
    (lineChartData.dailyForms.DailyForm.dailyFormsData || []).forEach(
        (value, index) => dailyFormData.push({
            name: inspectionType ( (index + 1).toString()),
            [inspectionType('DailyForm')]: value[index + 1], 
                    [inspectionType('PlantPreventive')]: lineChartData.dailyForms.PlantPreventive.dailyFormsData[index][index + 1],
            month: mm, year: yyyy, region: filterData.region || 'All'
        })
    );
    const monthlyFormData = [
        { name: 'SPCC', Complete: monthlyForms.MonthlySPCC.Complete, Incomplete: monthlyForms.MonthlySPCC.InComplete },
        {
            name: 'SpillLogs', Complete: monthlyForms.MonthlySpillLogs.Complete,
            Incomplete: monthlyForms.MonthlySpillLogs.InComplete
        },
        { name: 'SW', Complete: monthlyForms.MonthlySW.Complete, Incomplete: monthlyForms.MonthlySW.InComplete },
        {
            name: 'USTRect', Complete: monthlyForms.MonthlyUSTRect.Complete,
            Incomplete: monthlyForms.MonthlyUSTRect.InComplete
        },
        {
            name: 'USTSpill', Complete: monthlyForms.MonthlyUSTSpill.Complete,
            Incomplete: monthlyForms.MonthlyUSTSpill.InComplete
        },
    ];

    // const dailyFormSummary =
    //     [{ name: 'Complete', value: CompletedCount }, { name: 'Incomplete', value: InCompleteCount }];

    const dailyFormSummary = [
        {
            name: inspectionType('DailyForm'),
            Complete: dailyForms.DailyForm.complete,
            Incomplete: dailyForms.DailyForm.inComplete
        },
        {
            name: inspectionType('PlantPreventive'),
            Complete: dailyForms.PlantPreventive.complete,
            Incomplete: dailyForms.PlantPreventive.inComplete
        }
    ];

    const quarterlySummary = [
        {
            name: inspectionType('QTRVisual'),
            Complete: quarterlyForms.QTRVisual.Complete, Incomplete: quarterlyForms.QTRVisual.InComplete
        },
        {
            name: inspectionType('ShopInspection'), Complete: quarterlyForms.ShopInspection.Complete,
            Incomplete: quarterlyForms.ShopInspection.InComplete
        },
    ];

    return { monthlyFormData, dailyFormData, dailyFormSummary, quarterlySummary };
}

export async function getPlantDetails(plantId: string) {
    try {
        const response = await getDev(`plant/${plantId}`);
        savePlantDetails(response.data.data);
    } catch (error) {
        throw error;
    }
}

function getFilteredDate(formType: string) {
    if (formType.toLowerCase().indexOf('daily') > -1 && store.getState().dashboard.get('dailyFilter')) {
        const { date } = store.getState().dashboard.get('dailyFilter');
        return format(date, 'MM-DD-YYYY');
    } else if (formType.toLowerCase().indexOf('monthly') > -1 && store.getState().dashboard.get('monthlyFilter')) {
        const { date } = store.getState().dashboard.get('monthlyFilter');
        return format(date, 'MM-DD-YYYY');
    } else if ((formType === 'QTRVisual' || formType === 'ShopInspection')
        && store.getState().dashboard.get('quarterlyFilter')) {
        const { date } = store.getState().dashboard.get('quarterlyFilter');
        return format(date, 'MM-DD-YYYY');
    }
    return format(new Date(), 'MM-DD-YYYY');
}

export async function sendReminder(plantId: string, formType: string, instance) {
    try {
        const response = await postDev(`/remindemail`, {
            plantId,
            formType,
            date: getFilteredDate(formType)
        });
        toast.success('Email Sent Successfully.', {
            position: toast.POSITION.TOP_CENTER,
            className: 'success-toast'
        });
        if (instance) {
            instance.setState({
                showProgressBar: false,
                showDetails: false
            });
        }
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        throw error;
    }
}

export async function getFlaggedForms(type: string, mm: string, dd: string, yyyy: string,
    region: string, instance?) {
    try {
        const response = await getDev(`/getflaggedforms/${mm}${dd}${yyyy}/${region || 'All'}/${getCurrentUserUUID()}`);
        const { data: { data: respData } } = response;
        if (type === 'dailyForm') {
            const { dailyForms } = marshallFlaggedFormInstance(respData);
            saveFlaggedDailyFormsData(dailyForms, (`${respData.DailyCount}` || `${respData.totalCount}`));
        } else if (type === 'monthlyForm') {
            const { monthlyForms } = marshallFlaggedFormInstance(respData);
            saveFlaggedMonthlyFormsData(monthlyForms, (`${respData.MonthlyCount}` || `${respData.totalCount}`));
        } else if (type === 'ShopInspection') {
            const { quarterlyForms } = marshallFlaggedFormInstance(respData);
            saveFlaggedQuarterlyFormsData(quarterlyForms, (`${respData.QuarterlyCount}` || `${respData.totalCount}`));
        } else {
            const { dailyForms, monthlyForms, quarterlyForms } = marshallFlaggedFormInstance(respData);
            saveFlaggedMonthlyFormsData(monthlyForms, `${respData.MonthlyCount}`);
            saveFlaggedDailyFormsData(dailyForms, `${respData.DailyCount}`);
            saveFlaggedQuarterlyFormsData(quarterlyForms, `${respData.QuarterlyCount}`);
        }
        return response;
    } catch (error) {
        toast.error(SUBMISSION_FAILED, {
            position: toast.POSITION.TOP_CENTER,
            className: 'failed-toast'
        });
        (instance || this).setState({
            isLoading: false
        });
        throw error;
    }
}

function marshallFlaggedFormInstance(instance) {
    const newInstance = {
        dailyForms: [],
        monthlyForms: [],
        quarterlyForms: [],
    };
    for (const key in instance) {
        if (key === 'DailyForm') {
            instance[key].forEach(dailyFormData => {
                if (dailyFormData.PlantUId) {
                    newInstance.dailyForms.push({
                        UserName: dailyFormData.UserName,
                        Region: dailyFormData.Region,
                        PlantUId: dailyFormData.PlantUId,
                        UserId: dailyFormData.UserId,
                        FormId: dailyFormData.FormId,
                        State: dailyFormData.State,
                        UniqueId: dailyFormData.UniqueId,
                        PlantId: dailyFormData.PlantId,
                        Date: dailyFormData.Date,
                        Type: key,
                        Completed: dailyFormData.Completed,
                    });
                }
            });
        } else if (key === 'Quarterly') {
            (instance[key] instanceof Array ? instance[key] : []).forEach(quarterlyFormData => {
                if (quarterlyFormData.PlantUId) {
                    newInstance.quarterlyForms.push({
                        UserName: quarterlyFormData.UserName,
                        Type: key,
                        Region: quarterlyFormData.Region,
                        PlantUId: quarterlyFormData.PlantUId,
                        UserId: quarterlyFormData.UserId,
                        FormId: quarterlyFormData.FormId,
                        State: quarterlyFormData.State,
                        UniqueId: quarterlyFormData.UniqueId,
                        PlantId: quarterlyFormData.PlantId,
                        Date: quarterlyFormData.Date,
                        Completed: quarterlyFormData.Completed,
                    });
                }
            });
        } else {
            (instance[key] instanceof Array ? instance[key] : []).forEach(monthlyFormData => {
                if (monthlyFormData.PlantUId) {
                    newInstance.monthlyForms.push({
                        UserName: monthlyFormData.UserName,
                        Type: key,
                        Region: monthlyFormData.Region,
                        PlantUId: monthlyFormData.PlantUId,
                        UserId: monthlyFormData.UserId,
                        FormId: monthlyFormData.FormId,
                        State: monthlyFormData.State,
                        UniqueId: monthlyFormData.UniqueId,
                        PlantId: monthlyFormData.PlantId,
                        Date: monthlyFormData.Date,
                        Completed: monthlyFormData.Completed,
                    });
                }
            });
        }
    }
    return {
        dailyForms: newInstance.dailyForms,
        monthlyForms: newInstance.monthlyForms,
        quarterlyForms: newInstance.quarterlyForms
    };
}

export async function getFormDetails(UniqueId: string, type: string) {
    try {
        const response = await getDev(`flaggedanswers/${UniqueId}`);
        const questionsData: IFlaggedFormModelProps = { questions: [] };
        questionsData.questions.push({
            quesvalue: '',
            answer: response.data.data.PlantId,
            question: 'Plant Id',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesvalue: '',
            answer: response.data.data.ActualDate && format(response.data.data.ActualDate, 'MM/DD/YYYY'),
            question: 'Submission Date',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesvalue: '',
            answer: response.data.data.UserName,
            question: 'Submitted By',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesvalue: '',
            answer: response.data.data.FormType,
            question: 'Form Type',
            flaggedQuestion: false
        });
        
        for (const key in response.data.data.Answers) {
            const instance = marshallFormDetails(response.data.data.Answers[key], Number(key) - 1);
            questionsData.questions.push(instance);
        }
        saveFlaggedFormDetails(questionsData.questions);
        return response;
    } catch (error) {
        throw error;
    }
}

export async function getAllCompletedFlaggedForms(userId: string, formType: string,
    searchFor: string, category?: string, pageNumber?: number) {
    const previousInstances = FlaggedFormModel.list();
    previousInstances.forEach(element => {
        new FlaggedFormModel(element.props).$delete();
    });
    const url = searchFor === 'complete' ? 'flaggedcompleted' : 'flaggedincomplete';
    try {
        const response = await getDev(`${url}/${userId}/${formType}/${pageNumber}`);
        const newInstance = [];
       
        for (const key in (response.data.data && response.data.data.Forms)) {
            (response.data.data.Forms || []).forEach(flaggedFormData => {
                if (flaggedFormData.FormId) {
                    newInstance.push({
                        UserId: flaggedFormData.UserId,
                        Date: flaggedFormData.ActualDate === 'None' ? 'NA' :
                            format(flaggedFormData.ActualDate, 'MM/DD/YYYY'),
                        DateCompleted: flaggedFormData.DateCompleted === 'None' ? 'NA' :
                            format(flaggedFormData.DateCompleted, 'MM/DD/YYYY'),
                        DatePlant: flaggedFormData.DatePlant,
                        id: flaggedFormData.FormId,
                        type: flaggedFormData.FormType,
                        key: 'ListPageData',
                        CompletedBy: flaggedFormData.CompletedBy,
                        Region: flaggedFormData.Region,
                        FollowUpComments: flaggedFormData.FollowUpComments,
                        PlantId: flaggedFormData.PlantId,
                        category,
                        PagesCount: response.data.data.PagesCount
                    });
                }
            });
        }
        newInstance.forEach(instance => {
            new FlaggedFormModel(instance).$save();
        });
    } catch (error) {
        throw error;
    }
}

export async function getFormDetailsByType(formId: string) {
    try {
        const response = await getDev(`/getanswers/${formId}`);
        const questionsData: IFlaggedFormModelProps = { questions: [] };
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.UserName,
            question: 'Submitted By',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: format(response.data.data.ActualDate, 'MM/DD/YYYY'),
            question: 'Submission Date',
            flaggedQuestion: false
        });
        questionsData.questions.push({
            quesNum: questionsData.questions.length + 1,
            quesvalue: '',
            answer: response.data.data.PlantId,
            question: 'Plant Id',
            flaggedQuestion: false
        });
        objectToArray(response.data.data.Answers).forEach((formDetails, index) => {
            const instance = marshallFormDetails(formDetails, index, formId);
            questionsData.questions.push(instance);
        });
        questionsData.id = formId;
        questionsData.ImageUrls = response.data.data.ImageUrls;
        questionsData.SignatureUrls = response.data.data.SignatureUrls;
        questionsData.Completed = response.data.data.Completed !== 0;
        questionsData.Flagged = response.data.data.Flagged !== 0;
        questionsData.type = response.data.data.FormType;
        new FlaggedFormModel(questionsData).$save();
    } catch (error) {
        throw error;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/dashboardService.ts